// extracted by mini-css-extract-plugin
export default {"component":"Right_component__s9cSI"};